import { isNil } from '@wistia/type-guards';

/**
 * Copies a string to user's clipboard for easy pasting in another location
 *
 * @param {string} textToCopy - the string that will be copied to users clipboard
 * @returns {Promise<void>} - Promise object that resolves when the text is copied
 */
export const copyToClipboard = async (textToCopy: string): Promise<void> => {
  if (isNil(navigator.clipboard)) {
    throw new DOMException('The clipboard is not accessible', 'NotAllowedError');
  }

  return navigator.clipboard.writeText(textToCopy).catch((error: unknown) => {
    if (error instanceof Error) {
      throw error;
    }
    throw new DOMException('The clipboard is not accessible', 'NotAllowedError');
  });
};
